// eslint-disable-next-line import/prefer-default-export
export const TOKEN_WALLET_STATUSES_CONSTANTS = {
  PENDING: 'pending',
  SYNCING: 'syncing',
  SYNCING_INVESTOR_PAYS: 'syncing-investor-pays',
  READY: 'ready',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};
